import type { PathLookupEdgeType } from '@ipfabric/utils';
import {
  DRAG_ITEM,
  PathlookupDraggableProtocol,
  type PathlookupProtocolDragItem,
} from 'components/Graph/GraphSidePanel/PathLookupEdgeColors/PathlookupDraggableProtocol';
import { type FC, memo } from 'react';

interface Props {
  draggedProtocol: PathLookupEdgeType | null;
  onProtocolIsDraggedChange: (value: PathLookupEdgeType | null) => void;
  item: PathlookupProtocolDragItem;
}

const BarePathlookupDraggableProtocolPreview: FC<Props> = (props) => {
  if (
    props.draggedProtocol === null ||
    !props.item ||
    props.draggedProtocol !== props.item.name
  ) {
    return null;
  }

  return (
    <div className='graph-draggable-item__preview'>
      <div className='graph-draggable-item__box-shadow flex flex-row'>
        {props.item.type === DRAG_ITEM && (
          // Drag preview protocol
          <PathlookupDraggableProtocol
            color={props.item.color}
            draggedProtocol={null}
            index={props.item.index}
            name={props.item.name}
            onProtocolIsDraggedChange={props.onProtocolIsDraggedChange}
          />
        )}
      </div>
    </div>
  );
};

export const PathlookupDraggableProtocolPreview = memo(
  BarePathlookupDraggableProtocolPreview,
);
